import { render, staticRenderFns } from "./anomaly-record-add.vue?vue&type=template&id=3d8b392a&scoped=true"
import script from "./anomaly-record-add.vue?vue&type=script&lang=js"
export * from "./anomaly-record-add.vue?vue&type=script&lang=js"
import style0 from "./anomaly-record-add.vue?vue&type=style&index=0&id=3d8b392a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8b392a",
  null
  
)

export default component.exports